



























import { Component, Prop, Vue } from 'vue-property-decorator'

import AppCarouselScroll from '@/components/AppCarouselScroll.vue'

@Component({
  components: {
    AppCarouselScroll
  }
})
export default class extends Vue {
  @Prop(Array) readonly categories!: object[]

  get categoriesUpper () {
    return this.categories.filter((_, index) => index % 2 === 0)
  }

  get categoriesLower () {
    return this.categories.filter((_, index) => index % 2 === 1)
  }

  categoryStyle ({ medias }: { medias: { path: string }[] }) {
    if (!medias.length) return undefined
    return {
      backgroundImage: `url(${medias[0].path})`
    }
  }
}
